import { useSelector } from "react-redux";
import "./MainArea.css";
import { RootState } from "../../../store/store";
import { useCallback } from "react";
import Subscriptions from "../../../components/Subscriptions/Subscriptions";
import Profile from "../../../components/Profile/Profile";
import PrivacyConfig from "../../../components/PrivacyConfig/PrivacyConfig";

const MainArea = () => {
    const itemSelected = useSelector((state: RootState) => state.sidebar.itemSelected);

    const getMainAreaComponent = useCallback(() => {
        if(itemSelected === "subscriptions") return <Subscriptions />
        if(itemSelected === "profile")       return <Profile />
        if(itemSelected === "privacy-config") return <PrivacyConfig />

        return <div>Errore menù</div>;
    }, [ itemSelected ]);

    return(
        <>
            { getMainAreaComponent() }
        </>
    );
};

export default MainArea;